import { render, staticRenderFns } from "./AddMember.vue?vue&type=template&id=126917f6&"
import script from "./AddMember.vue?vue&type=script&lang=ts&"
export * from "./AddMember.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports